import React from 'react';
import styles from './InfoMessage.module.scss';

const InfoMessage = ({ width, children }) => {
    return (
        <p className={styles.infoMessage} style={{ width }}>
            {children}
        </p>
    );
};

export default InfoMessage;
